export default __webpack_public_path__ + "static/media/degree-progress-web.262f2f20.svg";